 
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const { phone, otp } = location.state || {}; 

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) return alert("Mismatch");

    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, otp, newPassword: password }),
      });

      if (res.ok) {
        alert("Password Changed!");
        navigate("/login");
      } else {
        alert("Error resetting password");
      }
    } catch (error) {
      alert("Server error");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <form onSubmit={handleReset} className="card p-4 shadow" style={{ width: 350 }}>
        <h4 className="text-center mb-3">New Password</h4>
        <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control mb-3" required />
        <input type="password" placeholder="Confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="form-control mb-3" required />
        <button className="btn btn-success w-100">Reset Password</button>
      </form>
    </div>
  );
}
export default ResetPassword;